/* Morning Friday — "Pack list" add-on popup */
(function () {
  if (window.MFXPack) return;
  var root, cfg, added = 0, lastFocus, shownKey = 'mfx-pack-shown';
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 8.5l4 4 8-9"/></svg>';

  function money(cents, currency) {
    try { return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: currency, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function t(key, vars) {
    var s = cfg.i18n[key] || key;
    Object.keys(vars || {}).forEach(function (k) { s = s.replace('{' + k + '}', vars[k]); });
    return s;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function getCart() { return fetch((cfg.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function build() {
    root = document.createElement('div');
    root.className = 'mfx-pack';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'mfx-pack-title');
    root.innerHTML =
      '<div class="mfx-pack__backdrop" data-close></div>' +
      '<div class="mfx-pack__card">' +
        '<div class="mfx-pack__head"><div class="mfx-pack__thumb"><img alt="" data-thumb><span class="mfx-pack__tick">' + CHECK + '</span></div>' +
        '<div><small>' + esc(t('added')) + '</small><b data-added-title></b><span data-added-meta></span></div>' +
        '<button type="button" class="mfx-pack__close" data-close aria-label="' + esc(t('close')) + '">&times;</button></div>' +
        '<div class="mfx-pack__summit" data-summit hidden><p data-summit-text></p><div class="mfx-pack__climb">' +
          '<svg viewBox="0 0 500 54" preserveAspectRatio="none" aria-hidden="true"><path class="mfx-c-ground" d="M0 54 L0 46 C60 44 90 40 140 38 C190 36 210 30 260 26 C310 22 330 18 380 14 C420 11 450 8 488 6 L500 6 L500 54 Z"/>' +
          '<path class="mfx-c-path" d="M8 44 C60 42 90 38 140 36 C190 34 210 28 260 24 C310 20 330 16 380 12 C420 9 450 7 488 6"/>' +
          '<path class="mfx-c-done" data-done d="M8 44 C60 42 90 38 140 36 C190 34 210 28 260 24 C310 20 330 16 380 12 C420 9 450 7 488 6"/></svg>' +
          '<span class="mfx-pack__climber" data-climber></span><span class="mfx-pack__flag"><span class="mfx-blaze"></span></span></div></div>' +
        '<div class="mfx-pack__body"><h2 class="mfx-pack__title" id="mfx-pack-title">' + esc(t('title')) + '</h2><p class="mfx-pack__sub">' + esc(t('sub')) + '</p><ul class="mfx-pack__list" data-list></ul></div>' +
        '<div class="mfx-pack__foot"><p class="mfx-pack__count" data-count hidden></p>' +
          '<button type="button" class="mfx-btn mfx-pack__ghost" data-keep>' + esc(t('keep')) + '</button>' +
          '<a class="mfx-btn mfx-btn--red" href="' + (cfg.root || '/') + 'checkout">' + esc(t('checkout')) + '</a></div>' +
      '</div>';
    document.body.appendChild(root);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) close();
      else if (e.target.closest('[data-keep]')) close();
      var b = e.target.closest('.mfx-pack__add');
      if (b) add(b);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = root.querySelectorAll('button, a[href], select');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function meter(cart) {
    var box = root.querySelector('[data-summit]');
    var th = cfg.thresholds && cfg.thresholds[cart.currency];
    if (!th) { box.hidden = true; return; }
    box.hidden = false;
    var total = cart.total_price, p = Math.max(0.02, Math.min(1, total / th));
    var txt = root.querySelector('[data-summit-text]');
    if (total >= th) { txt.innerHTML = '<strong>' + esc(t('unlocked')) + '</strong>'; root.classList.add('is-summit'); }
    else { txt.innerHTML = t('away', { amount: '<strong>' + esc(money(th - total, cart.currency)) + '</strong>' }); root.classList.remove('is-summit'); }
    var done = root.querySelector('[data-done]'), len = done.getTotalLength();
    done.style.strokeDasharray = len;
    done.style.strokeDashoffset = len;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        done.style.strokeDashoffset = len * (1 - p);
        var pt = done.getPointAtLength(len * p), svg = done.ownerSVGElement, w = svg.clientWidth / 500, h = svg.clientHeight / 54;
        var c = root.querySelector('[data-climber]');
        c.style.left = (pt.x * w) + 'px';
        c.style.top = (pt.y * h) + 'px';
      });
    });
  }

  function itemHTML(p) {
    var avail = p.variants.filter(function (v) { return v.available; });
    if (!avail.length) return '';
    var sel = avail.length > 1 || (avail[0].title && avail[0].title !== 'Default Title')
      ? '<select aria-label="' + esc(t('option')) + '">' + avail.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
      : '';
    return '<li class="mfx-pack__item" data-variant="' + avail[0].id + '">' +
      '<span class="mfx-pack__box" aria-hidden="true">' + CHECK + '</span>' +
      '<a class="mfx-pack__img" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div><a class="mfx-pack__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="mfx-pack__meta"><span>' + esc(money(avail[0].price, cfg.currency)) + '</span>' + sel + '</div></div>' +
      '<button type="button" class="mfx-pack__add">' + esc(t('add')) + '</button></li>';
  }

  function add(btn) {
    var li = btn.closest('.mfx-pack__item'), sel = li.querySelector('select');
    var id = sel ? sel.value : li.dataset.variant;
    btn.setAttribute('aria-busy', 'true');
    var err = li.querySelector('.mfx-pack__err'); if (err) err.remove();
    fetch((cfg.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(getCart)
      .then(function (cart) {
        btn.removeAttribute('aria-busy');
        li.classList.add('is-packed');
        btn.textContent = t('packed');
        if (sel) sel.disabled = true;
        added++;
        var cnt = root.querySelector('[data-count]');
        cnt.hidden = false;
        cnt.textContent = t(added === 1 ? 'count_one' : 'count_other', { n: added });
        meter(cart);
        var icon = document.querySelector('cart-icon');
        if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        li.insertAdjacentHTML('beforeend', '<p class="mfx-pack__err">' + esc(t('error')) + '</p>');
      });
  }

  function open(info) {
    var shown = +(sessionStorage.getItem(shownKey) || 0);
    if (shown >= (cfg.maxPerSession || 2)) return;
    getCart().then(function (cart) {
      cfg.currency = cart.currency;
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      var picks = cfg.items.filter(function (p) { return !inCart[p.id] && p.variants.some(function (v) { return v.available; }); }).slice(0, cfg.limit || 3);
      if (!picks.length) return;
      if (!root) build();
      added = 0;
      var last = info || {};
      if (!last.title && cart.items.length) { var li = cart.items[0]; last = { title: li.product_title, variant: li.variant_title, img: li.image }; }
      var th = root.querySelector('[data-thumb]');
      th.src = last.img || ''; th.hidden = !last.img;
      root.querySelector('[data-added-title]').textContent = last.title || '';
      root.querySelector('[data-added-meta]').textContent = last.variant && last.variant !== 'Default Title' ? last.variant : '';
      root.querySelector('[data-list]').innerHTML = picks.map(itemHTML).join('');
      root.querySelector('[data-count]').hidden = true;
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      meter(cart);
      sessionStorage.setItem(shownKey, shown + 1);
      setTimeout(function () { var b = root.querySelector('.mfx-pack__add'); if (b) b.focus({ preventScroll: true }); }, 400);
    }).catch(function () {});
  }

  function close() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open', 'is-summit');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (added) setTimeout(function () { location.reload(); }, 350);
  }

  window.MFXPack = {
    init: function (c) { cfg = c; },
    open: open,
    close: close
  };
})();
